import { createContext, useContext } from "react";

export const ZbritjetContext = createContext({});

export const useZbritjetContext = () => useContext(ZbritjetContext);
